import { ISerializableAppState } from '../../shared/common/state/app_state';
import { FastFilters } from './fast_filters';

import { init as initAdvanced } from './modules/advanced';
import { init as initDealType } from './modules/deal_type';
import { init as initGeoSuggest } from './modules/geo_suggest';
import { initRange, initSelect } from './modules/helpers';
import { init as initLocationSwitcher } from './modules/location_switcher';
import { init as initMap } from './modules/map';
import { init as initOfferType } from './modules/offer_type';
import { init as initRooms } from './modules/rooms';
import { init as initSearch } from './modules/search';
import { init as initWithPhoto } from './modules/with_photo';

export function init(state: ISerializableAppState) {
  const fastFilters = new FastFilters(state);

  const deinitAdvanced = initAdvanced(fastFilters);
  const deinitDealType = initDealType(fastFilters);
  const deinitGeoSuggest = initGeoSuggest(fastFilters);
  const deinitLocationSwitcher = initLocationSwitcher(fastFilters);
  const deinitMap = initMap(fastFilters);
  const deinitOfferType = initOfferType(fastFilters);
  const deinitPrice = initRange(fastFilters, 'priceField', fastFilters.setMinPrice, fastFilters.setMaxPrice);
  const deinitFromMKAD = initRange(fastFilters, 'fromMKAD', fastFilters.setMinFromMKAD, fastFilters.setMaxFromMKAD);
  const deinitLandArea = initRange(fastFilters, 'landArea', fastFilters.setMinLandArea, fastFilters.setMaxLandArea);
  const deinitArea = initRange(fastFilters, 'areaField', fastFilters.setMinArea, fastFilters.setMaxArea);
  const deinitPriceType = initSelect(fastFilters, 'priceType');
  const deinitRooms = initRooms(fastFilters);
  const deinitSearch = initSearch(fastFilters);
  const deinitWithPhoto = initWithPhoto(fastFilters);
  const deinitCurrencyType = initSelect(fastFilters, 'currencyType');

  return () => {
    deinitAdvanced();
    deinitDealType();
    deinitGeoSuggest();
    deinitLocationSwitcher();
    deinitMap();
    deinitOfferType();
    deinitCurrencyType();
    deinitPrice();
    deinitArea();
    deinitFromMKAD();
    deinitLandArea();
    deinitPriceType();
    deinitRooms();
    deinitSearch();
    deinitWithPhoto();

    return fastFilters;
  };
}
